<template>
  <div>
    <home-header />
    <div class="content page-width">
      <!-- 个人中心 -->
      <personal-center />
      <div class="margin-top-30"></div>
      <!-- 授课时间列表 -->
      <teach-time-page-list />
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import PersonalCenter from '@/common/components/PersonalCenter'
import TeachTimePageList from './components/TeachTimePageList'
export default {
  name: 'OfflineTeachList',
  components: {
    HomeHeader,
    PersonalCenter,
    TeachTimePageList,
    Foot
  },
  data: function () {
    return {
    }
  },
  created() { },
  methods: { },
  mounted () {
    // this.getDetailInfo()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.page-width{
  width:$pageWidth;
  margin:0 auto;
.content-right{
  margin-top:30px;
.localtion{
  line-height 30px;
  border-bottom:1px solid $borderColor;
  margin-bottom:20px;
}
}
}
.content-left{
  background:#f7f6f6;
}
</style>



// WEBPACK FOOTER //
// src/pages/offlineteach/Index.vue